module.exports = __webpack_public_path__ + "img/no-marketing-affilliate.8494ba74.png";